// CategoriesApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'Categories'];

// Enhance the base API service by adding entication-related tag types
const CategoriesApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
    
     
      // Fetch Categories profile query (GET request to /me)
      getCategoriesProducts: build.query({
        query: () => ({
          url: `/categoriesProduct`,
        }),
        providesTags: ['Categories'],
      }),  
      
      getAllSubCategoryByIdCategory: build.query({
        query: (categoryId) => ({
          url: `/getsubcategories/${categoryId}`,
          method: 'GET',
        }),
        providesTags: ['Categories'],
      }),
       
    }),
    overrideExisting: false,
  });

export default CategoriesApi;

// Exporting hooks for each endpoint to be used in components
export const {
   useGetCategoriesProductsQuery,
   useLazyGetAllSubCategoryByIdCategoryQuery
} = CategoriesApi;


